document.addEventListener("DOMContentLoaded", function () {
  let selectedColorElem = document.querySelector(
    ".product-form__input--swatch legend span"
  );

  let selectedColor = slugify(selectedColorElem.innerText);
  let currentPath = window.location.pathname;

  document.addEventListener("click", function (e) {
    const label = e.target.closest(
      ".product-form__input--swatch .swatch-input__label"
    );

    if (!label) return;

    setTimeout(() => {
      const input = label.parentElement.querySelector("input:checked");

      if (!input) return;

      const colorSlug = slugify(input.value);

      currentPath = currentPath.replace(selectedColor, colorSlug);

      selectedColor = colorSlug;
      window.location.href = currentPath;
    }, 1000);
  })
})

function slugify(text) {
  return text
    .toLowerCase()
    .trim()
    .replace(/\s+/g, "-")
    .replace(/[^\w-]/g, "");
}